import { CircularProgress, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import { Controller } from "react-hook-form";
import apiHelper from "../../../../util/ApiHelper";

export default function MovieSuggestionDropdown({ disabled, ...props }) {
  const {
    language,
    control,
    index,
    setValue,
    defaultValue,
    getValues,
    movieList,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  const getAllMovie = React.useCallback(
    async (keyword) => {
      try {
        const result = await apiHelper.cinefan.getAllMovies(
          language,
          "PUBLISHED",
          keyword
        );
        return result.data.content;
      } catch (err) {
        console.log(err);
      }
    },
    [language]
  );

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const result = await getAllMovie();

      if (active) {
        setOptions(result.filter(i => i));
      }
    })();

    return () => {
      active = false;
    };
  }, [loading, getAllMovie]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Controller
      name={`movieList.${index}`}
      control={control}
      defaultValue={defaultValue}
      rules={{
        required: movieList[index] && movieList[index].id ? false : "Required",
      }}
      render={({
        field: { value, onChange, ...rest },
        fieldState: { error },
      }) => {
        // console.log(value);
        return (
          <Autocomplete
            fullWidth
            id={`movies_${index}`}
            label="Remark"
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            getOptionSelected={(option, value) =>
              // console.log({ option, value });
              option.id === value.id
            }
            getOptionLabel={(option) => option.title}
            options={options}
            loading={loading}
            defaultValue={defaultValue}
            value={value}
            disabled={disabled}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  variant="outlined"
                  margin="dense"
                  placeholder="Select Movie"
                  error={!!error}
                  helperText={error ? error.message : ""}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              );
            }}
            onChange={(e, values) => {
              const currentValue = getValues(`movieList[${index}]`);
              setValue(`movieList.${index}`, {
                ...currentValue,
                id: values.id,
                title: values.title,
              });
              // setValue(`movieList.${index}._`, {
              //   ...currentValue,
              //   id: values.id,
              //   title: values.title,
              // });
            }}
            {...rest}
          />
        );
      }}
    />
  );
}
